export default __webpack_public_path__ + "static/media/agen_referral_gabung.9211c079.svg";